import { global } from '@storybook/global';
import type { JsonDocs } from '@stencil/core/internal';

export function isValidComponent(tagName: string) {
  if (!tagName) {
    return false;
  }
  if (typeof tagName === 'string') {
    return true;
  }
  throw new Error('Provided component needs to be a string. e.g. component: "my-element"');
}

export function isValidMetaData(customElements: JsonDocs) {
  if (!customElements) {
    return false;
  }

  if (customElements.components && Array.isArray(customElements.components)) {
    return true;
  }
  
  throw new Error(`You need to setup valid meta data in your stencil.config.js via docs-json output target.`);
}

/** @param customElements `any` for now as spec is not super stable yet */
export function setCustomElements(customElements: any) {
  global.__STORYBOOK_CUSTOM_ELEMENTS__ = customElements;
}

export function setCustomElementsManifest(customElements: any) {
  global.__STORYBOOK_CUSTOM_ELEMENTS_MANIFEST__ = customElements;
}

export function getCustomElements() {
  return global.__STORYBOOK_CUSTOM_ELEMENTS__ || global.__STORYBOOK_CUSTOM_ELEMENTS_MANIFEST__;
}
